<template>
  <div class="table mb-0 pt-3 bg-white rounded">
    <div class="expiry-data d-flex justify-content-between flex-wrap px-3 align-items-center mb-3">
      <div class="text-left">
      <h3 class="font-weight-bold f-20 text-left mb-0 text-black pl-0 pb-0">{{ $t('divisions.title') }}</h3>
       <span class="p-0 f-14">{{ $t('divisions.subtitle') }}</span>
      </div>
      <b-button @click="$bvModal.show('modal-division')" v-if="allowAddDivision"
        class="export equipment d-flex justify-content-center align-items-center w-fit-content" variant="primary">
        <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
        <p class="mb-0 ml-2 text-white px-0">{{ $t('divisions.addDivision') }}</p>
      </b-button>
    </div>
    <b-table :sticky-header="'calc(100vh - 273px)'" responsive :fields="translatedFields" :items="items" hover :per-page="perPage" :current-page="currentPage" show-empty>
      <template #cell(division)="data">
        <p class="mb-0">{{ data.value ? data.value : '-' }}</p>
      </template>
      <template #cell(usdot_number)="data">
        <p class="mb-0">{{ data.value ? data.value : '-' }}</p>
      </template>
      <template #cell(name)="data">
        <p class="mb-0">{{ data.value ? data.value : '-' }}</p>
      </template>
      <template #cell(phone)="data">
        <p class="mb-0">{{ data.value ? data.value : '-' }}</p>
      </template>
      <template #cell(address)="data">
        <p>{{ getAddress(data.item) }}</p>
      </template>
      <template #cell(action)="data">
        <svg v-if="!data.item.default && allowUpdateDivision" @click="editDivisionItem(data.item)" class="cursor-pointer" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z" fill="#2CCE89"/>
</svg>
        <div v-else>-</div>
      </template>
    </b-table>
    <div class="entries-pagination px-0 px-sm-2">
      <div class="d-flex align-items-center flex-wrap">
        <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
          <b-form-select v-model="perPage" :options="pageOptions" />
        </div>
        <div class="pagination">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
            aria-controls="my-table"></b-pagination>
        </div>
        <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
          {{ positionText }}
        </p>
      </div>
    </div>
    <b-modal id="modal-division" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
      :body-class="'equipment-edit-modal'" no-close-on-esc :header-class="'align-items-center'" scrollable>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ editDivisionFlag ? $t('divisions.editDivision') : $t('divisions.addDivision') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          Close Modal
        </b-button>
      </template>
      <div class="body">
        <b-row>
          <b-col class="mt-3" lg="12" md="12" sm="12">
            <b-form-group :label="$t('divisions.divisionLabel')" class="text-left label font-weight-normal">
              <b-form-input type="text" :placeholder="$t('divisions.divisionPlaceholder')" class="unit" v-model="divisionPayload.division"
                :disabled="!allowAddDivision && (!editDivisionFlag || (editDivisionFlag && !allowUpdateDivision))"></b-form-input>
              <p v-if="errors && errors.division" class="field-error mb-lg-3">
                {{ errors.division[0] }}
              </p>
            </b-form-group>
          </b-col>
          <b-col lg="12" md="12" sm="12">
            <b-form-group :label="$t('divisions.dotLabel')" class="text-left label font-weight-normal">
              <b-form-input type="number" :placeholder="$t('divisions.dotPlaceholder')" class="unit"
                v-model="divisionPayload.usdot_number"
                :disabled="!allowAddDivision && (!editDivisionFlag || (editDivisionFlag && !allowUpdateDivision))"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="12" md="12" sm="12">
            <b-form-group :label="$t('divisions.nameLabel')" class="text-left label font-weight-normal">
              <b-form-input type="text" :placeholder="$t('divisions.namePlaceholder')" class="unit" v-model="divisionPayload.name"
                :disabled="!allowAddDivision && (!editDivisionFlag || (editDivisionFlag && !allowUpdateDivision))"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="12" md="12" sm="12">
            <b-form-group :label="$t('divisions.addressLabel')" class="text-left label font-weight-normal">
              <b-form-input type="text" :placeholder="$t('divisions.addressPlaceholder')" class="unit" v-model="divisionPayload.address"
                :disabled="!allowAddDivision && (!editDivisionFlag || (editDivisionFlag && !allowUpdateDivision))"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="12" md="12" sm="12">
            <b-form-group :label="$t('divisions.cityLabel')" class="text-left label font-weight-normal">
              <b-form-input type="text" :placeholder="$t('divisions.cityPlaceholder')" class="unit" v-model="divisionPayload.city"
                :disabled="!allowAddDivision && (!editDivisionFlag || (editDivisionFlag && !allowUpdateDivision))"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group :label="$t('divisions.stateLabel')" class="text-left">
              <v-select class="bg_white w-100" v-model="divisionPayload.state" :options="states" item-value="id"
                item-text="label" :reduce="(option) => option.id"
                :disabled="!allowAddDivision && (!editDivisionFlag || (editDivisionFlag && !allowUpdateDivision))" />
            </b-form-group>
          </b-col>
          <b-col lg="12" md="12" sm="12">
            <b-form-group :label="$t('divisions.zipLabel')" class="text-left label font-weight-normal">
              <b-form-input type="text" :placeholder="$t('divisions.zipPlaceholder')" class="unit" v-model="divisionPayload.zipcode"
                :disabled="!allowAddDivision && (!editDivisionFlag || (editDivisionFlag && !allowUpdateDivision))"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="12" md="12" sm="12">
            <b-form-group :label="$t('divisions.phoneLabel')" class="text-left mb-0">
              <b-input-group size="lg" class="w-100" prepend="+1">
                <b-form-input v-mask="phoneMask" v-model="divisionPayload.phone"
                  :disabled="!allowAddDivision && (!editDivisionFlag || (editDivisionFlag && !allowUpdateDivision))"></b-form-input>
              </b-input-group>
              <p v-if="errors && errors.phone" class="field-error">
                {{ errors.phone[0] }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 mx-0">
          <b-button class="mx-0 h-40px w-100px m-0"
            :class="(allowAddDivision && !editDivisionFlag) || (editDivisionFlag && allowUpdateDivision) ? 'mr-3' : ''"
            @click="resetForm()" variant="secondary">{{ $t('divisions.cancel') }}</b-button>
          <div class="d-flex align-items m-0">
            <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="updateDivisionData()"
              v-if="(allowAddDivision && !editDivisionFlag) || (editDivisionFlag && allowUpdateDivision)">{{ $t('divisions.save') }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
import { checkPhoneFormat } from "../../services/helper";
export default {
  name: "Divisions",
  components: { vSelect },
  data() {
    return {
      checkPhoneFormat,
      editDivisionFlag: false,
      states: [],
      pageOptions: [
        {
          value: 10,
          text: "10",
        },
        {
          value: 25,
          text: "25",
        },
        {
          value: 50,
          text: "50",
        },
        {
          value: 100,
          text: "100",
        },
      ],
      divisionPayload: {
        division: "",
        name: "",
        address: "",
        city: "",
        zipcode: "",
        phone: "",
        state: null,
        usdot_number: ""
      },
      perPage: 50,
      currentPage: 1,
      items: [],
      errors: {},
      divisionID: null,

    }
  },
  computed: {
    ...mapGetters(['allCountries', 'rolePermissions']),
    translatedFields() {
      return [
        { key: "division", label: this.$t('divisions.divisionColumn'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "usdot_number", label: this.$t('divisions.dotColumn'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "name", label: this.$t('divisions.nameColumn'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "address", label: this.$t('divisions.addressColumn'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "phone", label: this.$t('divisions.phoneColumn'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "action", label: this.$t('divisions.actionColumn'), sortable: true, thClass: 'font-table-weight-bold' },
      ];
    },
    allowViewDivision() {
      return this.rolePermissions && this.rolePermissions['Division'] && this.rolePermissions['Division'][0].allow
    },
    allowAddDivision() {
      return this.rolePermissions && this.rolePermissions['Division'] && this.rolePermissions['Division'][2].allow
    },
    allowUpdateDivision() {
      return this.rolePermissions && this.rolePermissions['Division'] && this.rolePermissions['Division'][1].allow
    },
    allowDeleteDivision() {
      return this.rolePermissions && this.rolePermissions['Division'] && this.rolePermissions['Division'][3].allow
    },
    rows() {
      return this.items.length;
    },
    phoneMask() {
      return this.divisionPayload?.phone?.length > 0
        ? [
          /\d/, /\d/, /\d/, " ",
          /\d/, /\d/, /\d/, " ",
          /\d/, /\d/, /\d/, /\d/
        ]
        : false; // Allows empty input
    },
    positionText() {
      const endIndex = this.currentPage * this.perPage;
      const startIndex = this.rows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
      const end = endIndex > this.rows ? this.rows : endIndex;
      return this.$t('divisions.positionText', { start: startIndex, end, total: this.rows });
    }
  },
  methods: {
    ...mapActions(['getAllCountries', 'getAllDivisions', 'updateDivision', 'setLoader', 'setNotification', 'addDivision']),
    checkNullValues(payload) {
      let nullKeys = [];
      for (let [key, value] of Object.entries(payload)) {
        if (!value) {
          nullKeys.push(key);
        }
      }
      return nullKeys;
    },
    editDivisionItem(data) {
      this.editDivisionFlag = true
      this.divisionPayload = {
        division: data.division,
        name: data.name,
        address: data.address,
        city: data.city,
        zipcode: data.zipcode,
        phone: data.phone,
        state: data.state.id,
        usdot_number: data.usdot_number
      }
      this.divisionID = data.id
      this.$bvModal.show('modal-division')
    },
    getAddress(data) {
      const address = `${data.address ? `${data.address}, ` : ''}${data.city ? `${data.city}, ` : ''}${data.state ? `${data.state.name} ` : ''}${data.zipcode ? `${data.zipcode}` : ''}`
      if (address) return address
      return '-'
    },
    async getCountries() {
      await this.getAllCountries();
      const countries = this.allCountries.map((item) => ({
        id: item.id,
        label: item.name,
      }));
      this.getStates(countries[0]);
    },
    getStates(selectedOption) {
      this.states = this.allCountries
        .filter((country) => country.id === selectedOption.id)[0]
        .state.map((item) => ({
          id: item.id,
          label: item.name,
        }));
      this.divisionPayload.state = this.states.filter(
        (state) => state.label === "-"
      )[0].id;
    },
    resetForm() {
      this.errors = {}
      this.$bvModal.hide('modal-division')
      this.editDivisionFlag = false,
        this.divisionPayload = {
          division: "",
          name: "",
          address: "",
          city: "",
          zipcode: "",
          phone: "",
          usdot_number: "",
          state: this.states.filter(
            (state) => state.label === "-"
          )[0].id
        }
    },
    async updateDivisionData() {
      try {
        this.errors = {}
        const nullKeys = this.checkNullValues({
          division: this.divisionPayload.division
        });
        if (this.divisionPayload.phone) {
          if (!this.checkPhoneFormat(this.divisionPayload.phone)) {
            throw {
              phone: [this.$t('divisions.wrongFormat')],
            };
          }
        }
        if (nullKeys.length === 0) {
          let successMsg = this.$t('divisions.divisionAdded')
          if (this.editDivisionFlag) {
            successMsg = this.$t('divisions.divisionUpdated')
            try {
              this.setLoader(true)
              await this.updateDivision({
                id: this.divisionID,
                payload: { ...this.divisionPayload, company: this.userCompany }
              })
            }
            catch (e) {
              this.setLoader(false)
              await this.setNotification({
                msg: e,
                type: "error",
                color: "red",
              });
              return
            }
          }
          else {
            try {
              this.setLoader(true)
              await this.addDivision({ ...this.divisionPayload, company: this.userCompany })
            }
            catch (e) {
              this.setLoader(false)
              await this.setNotification({
                msg: e,
                type: "error",
                color: "red",
              });
              return
            }
          }
          await this.setNotification({
            msg: successMsg,
            type: "success",
            color: "green",
          });
          this.setLoader(false)
          this.resetForm()
          this.getDivisionData()
        }
        else {
          let error = {};
          nullKeys.forEach((x) => {
            error[x] = [this.$t('divisions.fieldRequired')];
          });
          throw error;
        }
      }
      catch (error) {
        if (typeof error === "object") {
          this.errors = error;
          // eslint-disable-next-line no-ex-assign
        }
      }
    },
    async getDivisionData() {
      try {
        const data = await this.getAllDivisions()
        this.items = []
        data.map((item) => {
          this.items.push({
            division: item.division,
            name: item.name,
            phone: item.phone,
            address: item.address,
            state: item.state_obj,
            city: item.city,
            zipcode: item.zipcode,
            id: item.id,
            default: item.default,
            usdot_number: item.usdot_number
          })
        })

      }
      catch (e) {
        console.log(e)
      }
    }
  },
  async mounted() {
    await this.getCountries();
    await this.getDivisionData()

  }
}
</script>